import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => { require(['@/views/home.vue'], resolve) },
      redirect: { path: '/index.html' },
      children: [
        {
          path: 'index.html', //首页
          name: 'index',
          component: () => import('@/views/index/index.vue')
        },
        {
          path: 'appCustomized.html', //app定制
          name: 'appCustomized',
          component: () => import('@/views/solution/appCustomized.vue')
        },
        {
          path: 'contentCustomized.html', //app内容定制
          name: 'contentCustomized',
          component: () => import('@/views/solution/contentCustomized.vue')
        },
        {
          path: 'appBuild.html', //app建筑
          name: 'appBuild',
          component: () => import('@/views/solution/appBuild.vue')
        },
        {
          path: 'appPlan.html', //app创意策划
          name: 'appPlan',
          component: () => import('@/views/solution/appPlan.vue')
        },
        {
          path: 'adviser.html', //家具设计顾问
          name: 'adviser',
          component: () => import('@/views/solution/adviser.vue')
        },
        {
          path: 'case.html', //案例
          name: 'case',
          component: () => import('@/views/case/case.vue')
        },
        {
          path: 'company.html', //公司动态
          name: 'company',
          component: () => import('@/views/us/company.vue')
        },
        {
          path: 'contact.html', //联系我们
          name: 'contact',
          component: () => import('@/views/us/contact.vue')
        },
        {
          path: 'news.html', //联系我们
          name: 'news',
          component: () => import('@/views/us/news.vue')
        }
      ]
    }
  ]
})
export default  router



// WEBPACK FOOTER //
// ./src/router/index.js